import BaseController from './base_controller'

export default class extends BaseController {
  static targets = ['form']

  connect() {
    this.boundGroupChanged = this.handleGroupChanged.bind(this)
    window.addEventListener('vessel-group:active-group-changed', this.boundGroupChanged)
  }

  disconnect() {
    window.removeEventListener('vessel-group:active-group-changed', this.boundGroupChanged)
  }

  handleGroupChanged({ detail: { groupId } }) {
    if (!this.hasFormTarget) return
    const url = new URL(this.formTarget.action, window.location.origin)
    url.searchParams.set('group_id', groupId)
    this.formTarget.action = url.toString()
  }
}
